export default __webpack_public_path__ + "bd05dda44b808c79b6ebba427a17edb5.svg";